var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPostIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_94)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.6617 161.339L38.6615 161.338C11.8794 134.562 5.52243 93.9592 22.8356 60.3119C24.2272 57.6118 27.5377 56.5497 30.245 57.936C32.9448 59.3216 34.0123 62.6377 32.6206 65.3444C17.5026 94.7282 23.0518 130.181 46.4383 153.561C60.7415 167.871 79.7636 175.75 100 175.75C120.23 175.75 139.258 167.871 153.562 153.561C167.865 139.252 175.75 120.23 175.75 100C175.75 79.7636 167.871 60.7415 153.561 46.4383C139.252 32.1354 120.237 24.25 100 24.25C79.7635 24.25 60.7415 32.1353 46.4384 46.4384C44.2875 48.5893 40.8124 48.5893 38.6616 46.4384C36.5107 44.2876 36.5107 40.8124 38.6616 38.6616C55.046 22.2771 76.824 13.25 100 13.25C123.176 13.25 144.96 22.2772 161.338 38.6615L161.339 38.6617C177.729 55.046 186.75 76.8239 186.75 100C186.75 123.17 177.729 144.954 161.339 161.338L161.338 161.339C144.96 177.729 123.176 186.75 100 186.75C76.8239 186.75 55.046 177.729 38.6617 161.339Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 136.75C96.9637 136.75 94.5 134.292 94.5 131.25V68.75C94.5 65.7142 96.9642 63.25 100 63.25C103.036 63.25 105.5 65.7142 105.5 68.75V131.25C105.5 134.292 103.036 136.75 100 136.75Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.25 105.5H68.75C65.7142 105.5 63.25 103.036 63.25 100C63.25 96.9642 65.7142 94.5 68.75 94.5H131.25C134.292 94.5 136.75 96.9637 136.75 100C136.75 103.036 134.292 105.5 131.25 105.5Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_94"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostIcon);
export default __webpack_public_path__ + "static/media/PostIcon.dff9c8f3dcefb9966e6cf974cc89e367.svg";
export { ForwardRef as ReactComponent };